/**
 * Dropdown for lbbw-am.de
 *
 * @author Florian Gutwald
 * Converted to Plain JS
 */
export class Dropdown {
  constructor(element, options = {}) {
    this.element = element;
    this.options = Object.assign({}, options);

    this.init();
  }

  /**
   * Init method
   */
  init() {
    this.dropdownBtn = this.element.querySelector('.js_dropdown_btn');
    this.dropdownList = this.element.querySelector('.js_dropdown_list');
    if (!this.dropdownBtn || !this.dropdownList) return;

    this.dropdownListItems = Array.from(this.dropdownList.querySelectorAll('li'));

    // Set initial ARIA attributes
    this.dropdownBtn.setAttribute('aria-haspopup', 'true');
    this.dropdownBtn.setAttribute('aria-expanded', 'false');
    this.dropdownList.setAttribute('role', 'listbox');
    this.dropdownListItems.forEach(item => {
      item.setAttribute('role', 'option');
      item.setAttribute('tabindex', '-1');
    });

    // Click handlers
    this.dropdownBtn.addEventListener('click', () => this.toggleList());

    this.dropdownListItems.forEach(item => {
      item.addEventListener('click', () => this.action(item));
    });

    // Keyboard handlers for the button
    this.dropdownBtn.addEventListener('keydown', (e) => {
      if (['Enter', ' '].includes(e.key)) {
        e.preventDefault();
        this.toggleList();

        if (this.element.classList.contains('dropdown__active')) {
          this.dropdownListItems[0]?.focus();
        }
      }

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!this.element.classList.contains('dropdown__active')) {
          this.toggleList();
        }
        this.dropdownListItems[0]?.focus();
      }
    });

    // Keyboard handlers for the list items
    this.dropdownListItems.forEach((item, index) => {
      item.addEventListener('keydown', (e) => {
        const items = this.dropdownListItems;
        let nextIndex;

        switch (e.key) {
          case 'Enter':
          case ' ':
            e.preventDefault();
            this.action(item);
            break;
          case 'ArrowDown':
            e.preventDefault();
            nextIndex = (index + 1) % items.length;
            items[nextIndex].focus();
            break;
          case 'ArrowUp':
            e.preventDefault();
            nextIndex = (index - 1 + items.length) % items.length;
            items[nextIndex].focus();
            break;
          case 'Escape':
            e.preventDefault();
            this.closeList();
            this.dropdownBtn.focus();
            break;
          case 'Home':
            e.preventDefault();
            items[0].focus();
            break;
          case 'End':
            e.preventDefault();
            items[items.length - 1].focus();
            break;
        }
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.element.contains(e.target)) {
        this.closeList();
      }
    });

    // Global Escape listener
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.element.classList.contains('dropdown__active')) {
        this.closeList();
        this.dropdownBtn.focus();
      }
    });
  }

  /**
   * Toggle list
   */
  toggleList() {
    const isActive = this.element.classList.toggle('dropdown__active');
    this.dropdownList.classList.toggle('dropdown-list__open');

    // Update ARIA expanded state
    this.dropdownBtn.setAttribute('aria-expanded', isActive);

    // Set tabindex based on expanded state
    this.dropdownListItems.forEach(item => {
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });
  }

  /**
   * Close list
   */
  closeList() {
    this.element.classList.remove('dropdown__active');
    this.dropdownList.classList.remove('dropdown-list__open');
    this.dropdownBtn.setAttribute('aria-expanded', 'false');

    this.dropdownListItems.forEach(item => {
      item.setAttribute('tabindex', '-1');
    });
  }

  /**
   * List item action
   */
  action(element) {
    const url = element.dataset.value;
    if (url) {
      window.location.href = url;
    }
  }
}
